import { createContext } from 'react';

const ConsultContext = createContext({} as any);

export default ConsultContext;
